module.exports = __webpack_public_path__ + "img/veloshop.ca_Mobile__1551459935_76.67.188.141.9dfef5d0.jpg";